/* Manchester · Wishlist → Klaviyo (propiedades de perfil) — 2026-08-03
 *
 * POR QUÉ EXISTE ESTE ARCHIVO
 * El evento "Added to Wishlist" que ya emite manchester-wishlist.js sirve para
 * disparar flows (recomendar similares, avisar de bajada de precio). Lo que NO
 * sirve es para campañas del tipo "los productos que guardaste están con
 * descuento", porque un stream de eventos no tiene estado:
 *   - no sabes qué tiene alguien guardado AHORA, solo qué guardó alguna vez;
 *   - los descartes son invisibles (no mandamos remove_from_wishlist a Klaviyo),
 *     así que mandarías un descuento de algo que la persona quitó hace semanas.
 *
 * Esto escribe la lista como PROPIEDAD DE PERFIL, que sí es estado: se
 * sobrescribe entera en cada cambio, así que los descartes desaparecen solos y
 * la plantilla del email puede recorrer `person.wishlist_items`.
 *
 * Segmentación resultante: wishlist_count > 0.
 *
 * LÍMITE CONOCIDO: la wishlist es anónima (localStorage). Klaviyo cuelga estas
 * propiedades del perfil que esté rastreando — anónimo vía cookie __kla_id, o
 * identificado si la persona ya dejó su correo. El perfil anónimo se fusiona con
 * el identificado cuando más tarde se identifica, así que escribir siempre da
 * mejor cobertura que esperar al login. Pero el tráfico que NUNCA deja correo no
 * es alcanzable por email, y eso no lo arregla ningún código.
 */
(function () {
  'use strict';

  var DEBOUNCE_MS = 1500;
  var MAX_ITEMS = 20;      /* tope para no inflar el perfil ni la plantilla */
  var CONCURRENCY = 4;

  var cache = {};          /* handle -> item, por sesión de página */
  var timer = null;
  var lastSerialized = null;

  function klaviyoReady() {
    return typeof window._learnq !== 'undefined' && window._learnq;
  }

  function fetchProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) return null;          /* borrado o despublicado: se omite */
        return res.json();
      })
      .then(function (p) {
        if (!p) return null;
        var item = {
          ProductID: String(p.id),
          Handle: p.handle,
          ProductName: p.title,
          URL: window.location.origin + '/products/' + p.handle,
          ImageURL: p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '',
          Price: p.price / 100,
          ComparePrice: p.compare_at_price ? p.compare_at_price / 100 : null,
          OnSale: !!(p.compare_at_price && p.compare_at_price > p.price),
          Available: !!p.available,
          Brand: p.vendor || '',
          Categories: p.type ? [p.type] : []
        };
        cache[handle] = item;
        return item;
      })
      ['catch'](function () { return null; });
  }

  function fetchAll(handles) {
    var results = new Array(handles.length);
    var next = 0;
    function worker() {
      if (next >= handles.length) return Promise.resolve();
      var i = next++;
      return fetchProduct(handles[i]).then(function (it) {
        results[i] = it;
        return worker();
      });
    }
    var workers = [];
    for (var w = 0; w < Math.min(CONCURRENCY, handles.length); w++) workers.push(worker());
    return Promise.all(workers).then(function () { return results; });
  }

  function sync() {
    if (!klaviyoReady() || !window.MFGWishlist) return;

    var handles = window.MFGWishlist.list()
      .slice()
      .sort(function (a, b) { return b.t - a.t; })   /* más reciente primero */
      .map(function (e) { return e.h; })
      .slice(0, MAX_ITEMS);

    if (!handles.length) {
      push([], 0);
      return;
    }

    fetchAll(handles).then(function (items) {
      var clean = items.filter(Boolean);
      push(clean, clean.length);
    });
  }

  function push(items, count) {
    /* No reescribir si nada cambió — evita ruido en el perfil y llamadas de más
       cuando el evento wishlist:change se dispara varias veces seguidas. */
    var serialized = JSON.stringify(items);
    if (serialized === lastSerialized) return;
    lastSerialized = serialized;

    try {
      window._learnq.push(['identify', {
        wishlist_items: items,
        wishlist_count: count,
        wishlist_updated_at: new Date().toISOString()
      }]);
    } catch (e) { /* analytics nunca debe romper la UI */ }
  }

  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(sync, DEBOUNCE_MS);
  }

  document.addEventListener('wishlist:change', schedule);

  /* Sincronizar también al cargar: la lista pudo cambiar en otra pestaña o en
     una sesión anterior, y el perfil de Klaviyo puede estar desactualizado. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  /* Expuesto para depuración y para el harness de consola. */
  window.MFGWishlistKlaviyo = { sync: sync, _cache: cache };
})();
